import React from "react";
import { stats } from "../data/landing";
export function StatsStrip() {
  return <section className="stats-band" aria-label="The kit at a glance" data-id="element-232" data-mp="ghf7ebxmgv5j">
      <dl className="shell stats-grid" data-id="element-233" data-mp="gfkjcor20mx8">
        {stats.map(s => <div key={s.label} data-id="element-234" data-mp="2j7a22wobrtu">
            <dt data-id="element-235" data-mp="2k8p0igt8ygu">{s.label}</dt>
            <dd data-id="element-236" data-mp="7ggybf8btxg3">{s.value}</dd>
          </div>)}
      </dl>
    </section>;
}